<template>
    <div class="contentContacto">
        <div id="contactanos" class="ancla"></div>
        <div class="contacto">
            <div class="content">
                <b-row>
                    <b-col cols="12" lg="5">
                        <h2 v-if="lang == 'eng'">Consult our advisoris to design your custom made plan</h2>
                        <h2 v-else-if="lang == 'esp'">Consulta a nuestros asesores para diseñar tu plan a la medida</h2>
                        <p><img src="../assets/img/icn_mail.svg" alt="Correo"> info@bordercomercial.com</p>
                        <p><img src="../assets/img/icn_phone.svg" alt="Correo"> (664) 782 0935</p>
                        <div class="small">
                            <small>Border Comercial. 2020</small>
                            <small v-if="lang == 'eng'">All rights reserved.</small>
                            <small v-else-if="lang == 'esp'">Todos los derechos reservados.</small>
                        </div>
                    </b-col>
                    <b-col cols="12" lg="6" offset-lg="1">
                        <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                            <float-label>
                                <b-form-input
                                v-model="name"
                                type="text"
                                required
                                placeholder="Name & Last name"
                                v-if="lang == 'eng'"
                                ></b-form-input>

                                <b-form-input
                                v-model="name"
                                type="text"
                                required
                                placeholder="Nombre y Apellido"
                                v-else-if="lang == 'esp'"
                                ></b-form-input>
                            </float-label>

                            <float-label>
                                <b-form-input
                                v-model="phone"
                                type="tel"
                                required
                                placeholder="Phone Number"
                                v-if="lang == 'eng'"
                                ></b-form-input>

                                <b-form-input
                                v-model="phone"
                                type="tel"
                                required
                                placeholder="Teléfono"
                                v-else-if="lang == 'esp'"
                                ></b-form-input>
                            </float-label>
                            
                            <float-label>
                                <b-form-input
                                v-model="email"
                                type="email"
                                required
                                placeholder="Email"
                                v-if="lang == 'eng'"
                                ></b-form-input>
                                
                                <b-form-input
                                v-model="email"
                                type="email"
                                required
                                placeholder="Correo electrónico"
                                v-else-if="lang == 'esp'"
                                ></b-form-input>
                            </float-label>

                            <float-label>
                                <b-form-input
                                v-model="asunto"
                                type="text"
                                required
                                placeholder="Subject"
                                v-if="lang == 'eng'"
                                ></b-form-input>
                                
                                <b-form-input
                                v-model="asunto"
                                type="text"
                                required
                                placeholder="Asunto"
                                v-else-if="lang == 'esp'"
                                ></b-form-input>
                            </float-label>

                            <!-- <float-label :dispatch="false">
                                <select v-model="interes" v-if="lang == 'eng'">
                                    <option disabled selected :value="null">Interested in</option>
                                    <option>Option 1</option>
                                </select>

                                <select v-model="interes" v-else-if="lang == 'esp'">
                                    <option disabled selected :value="null">Interesado en</option>
                                    <option>Opción 1</option>
                                </select>
                            </float-label> -->

                            <float-label>
                                <b-form-input
                                v-model="message"
                                type="text"
                                required
                                placeholder="Message"
                                v-if="lang == 'eng'"
                                ></b-form-input>

                                <b-form-input
                                v-model="message"
                                type="text"
                                required
                                placeholder="Mensaje"
                                v-else-if="lang == 'esp'"
                                ></b-form-input>
                            </float-label>

                            <b-button v-if="lang == 'eng'" type="submit">Send</b-button>
                            <b-button v-else-if="lang == 'esp'" type="submit">Enviar</b-button>
                        </b-form>
                    </b-col>
                </b-row>
            </div>
        </div>
        <div class="content">
            <hr>
        </div>

        <b-modal ref="exito" centered hide-footer>
            <h3>¡Gracias!</h3>
            <p class="my-4">Su mensaje ha sido enviado.</p>
        </b-modal>
        <b-modal ref="error" centered hide-footer>
            <h3>Lo sentimos</h3>
            <p class="my-4">Hubo un error al enviar su mensaje, <br>intente de nuevo más tarde.</p>
        </b-modal>
        <b-modal ref="cargando" centered hide-footer>
            <h3>Cargando...</h3>
        </b-modal>
    </div>
</template>

<script>
    import axios from 'axios'
    import {mapState, mapActions, mapMutations} from 'vuex'
    import FloatLabel from 'vue-float-label/components/FloatLabel'
    export default {
        computed:{
            ...mapState(['lang'])
        },
        components: {
            FloatLabel
        },
        data() {
            return {
                name: '',
                phone: '',
                email: '',
                interes: null,
                asunto: '',
                message: '',
                show: true,
                form: 'contactHome',
                isLoading: false,
                fullPage: true,
            }
        },
        methods: {
            onSubmit(evt) {
                evt.preventDefault()
                this.$refs['cargando'].show();
                const formData = new FormData()
                formData.append('name', this.name)
                formData.append('phone', this.phone)
                formData.append('email', this.email)
                formData.append('interes', this.interes)
                formData.append('asunto', this.asunto)
                formData.append('message', this.message)
                formData.append('contact', 'contact')
                axios.post('/static/sendMail.php', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response)=> {
                    console.log(response)
                    this.$refs['cargando'].hide();
                    if(response.data == 1){
                        this.$refs['exito'].show();
                        setTimeout(()=>{ this.$refs['exito'].hide() }, 3000)
                        this.onReset()
                    }
                    else{
                        this.$refs['error'].show();
                        setTimeout(()=>{ this.$refs['error'].hide(); }, 3000)
                    }   
                })
                .catch((error)=> {
                    this.$refs['cargando'].hide();
                    console.log(error)
                    this.$refs['error'].show();
                    setTimeout(()=>{ this.$refs['error'].hide(); }, 3000)
                })
            },
            onReset(evt) {
                // evt.preventDefault()
                // Reset our form values
                this.name = '',
                this.phone = '',
                this.email = '',
                this.interes = '',
                this.asunto = '',
                this.message = '',
                // Trick to reset/clear native browser form validation state
                this.show = false
                this.$nextTick(() => {
                this.show = true
                })
            }
        }
    }
</script>

<style scoped>
    .contentContacto{
        background-color: #F14C28;
        position: relative;
    }
    .contacto{
        padding: 100px 0;
        position: relative;
    }
    .contacto *{
        color: white;
    }
    h2{
        margin-bottom: 30px;
    }
    p{
        font-size: 10pt;
        margin-top: 10px;
    }
    img{
        width: 18px;
        margin-right: 10px;
    }
    .form-control{
        box-shadow: none!important;
        border:none!important;
        padding: 20px 0;
        border-radius: inherit!important;
        margin-bottom: 40px;
        background-color: transparent!important;
        border-bottom: 2px solid white!important;
    }
    select{
        background-color: transparent!important;
        width: 100%;
        height: 42px;
        margin-bottom: 40px;
        border:none!important;
        border-bottom: 2px solid white!important;
    }
    select option{
        color: #383838!important;
    }
    option:disabled {
        color: rgb(170, 170, 170)!important;
    }
    .btn{
        background-color: #068C93!important;
        color: white!important;
        font-family: 'sailecBold';
        border-radius: 100px!important;
        font-size: 12pt!important;
        width: 130px;
        -webkit-box-shadow: 0px 5px 10px 0px rgba(56,163,169,1)!important;
        -moz-box-shadow: 0px 5px 10px 0px rgba(56,163,169,1)!important;
        box-shadow: 0px 5px 10px 0px rgba(56,163,169,1)!important;
    }
    .small{
        margin-top: 40px;
    }
    small{
        display: block;
    }
    hr{
        margin: 0;
        border-top: 2px solid white;
    }
</style>
<style>
    .form-control::placeholder, .vfl-label{
        color: white!important;
    }

    .modal-content{
        border-radius: inherit;
        -webkit-box-shadow: 2px 0px 30px 0px rgba(0,0,0,1);
        -moz-box-shadow: 2px 0px 30px 0px rgba(0,0,0,1);
        box-shadow: 2px 0px 30px 0px rgba(0,0,0,1);
    }
    .modal-header{
        border-bottom: none;
        position: relative;
        box-shadow: none!important;
    }
    .modal-header .close{
        outline: none!important;
    }
    .modal-body{
        padding: 0 20px 61.6px 20px;
    }
    .modal-body h3{
        color: #EF4E28;
        text-align: center;
        font-size: 30pt!important;
    }
    .modal-body p{
        color: #171717;
        text-align: center;
        font-size: 12pt;
    }
</style>


// WEBPACK FOOTER //
// src/components/Contacto.vue